module.exports = __webpack_public_path__ + "static/media/1-3.e80eb6a7.png";